module.exports = __webpack_public_path__ + "static/media/ghost.4f027d27.svg";